import { useFormContext } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { currentOrganizationSelector } from 'selectors/current_organization';
import { useGetAvailabilityEventTypesQuery } from '../api';
import { useLinkedAvailabilityEventTypes } from '../hooks';
const footerCss = "f6xa9tv";
const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(footerCss, props.className)} />;
});
export const PopupFooter = ({
  selectedScheduleId,
  currentEventType,
  onClose
}) => {
  const {
    data,
    isFetching,
    isError
  } = useGetAvailabilityEventTypesQuery();
  const {
    isSubmitting
  } = useFormContext();
  const isLoading = isFetching || isSubmitting;
  const currentOrganization = useSelector(currentOrganizationSelector);
  const ownerName = currentOrganization?.owner.name;
  const managerCount = currentOrganization.managing_members_count;
  const initLinkedEventTypes = useLinkedAvailabilityEventTypes(data, selectedScheduleId, ownerName, managerCount, currentEventType);
  const linkedEventTypesCount = initLinkedEventTypes.reduce((sum, profile) => sum + profile.eventTypes.length, 0);
  const initLinkedEventTypesCount = currentEventType ? linkedEventTypesCount + 1 : linkedEventTypesCount;
  const noLinkedEventTypes = !isFetching && (!data || isError);
  return <Footer>
      <Button decoration="secondary-outline" onClick={onClose}>
        {I18n.t('publisher.action.cancel')}
      </Button>
      <Button aria-label={isLoading ? I18n.t('publisher.messages.loading') : null} type="submit" loading={isLoading} disabled={noLinkedEventTypes}>
        {I18n.t('publisher.availability.schedules.apply_to_n_event_types', {
        count: initLinkedEventTypesCount
      })}
      </Button>
    </Footer>;
};

require("./popup_footer.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./popup_footer.js");